import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { LeistungenPage } from './pages/LeistungenPage';
import { RechnerPage } from './pages/RechnerPage';
import { AppPage } from './pages/AppPage';
import { BeratungPage } from './pages/BeratungPage';
import { UeberUnsPage } from './pages/UeberUnsPage';
import { FAQPage } from './pages/FAQPage';
import { KontaktPage } from './pages/KontaktPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={setCurrentPage} data-id="element-0" />;
      case 'leistungen':
        return <LeistungenPage onNavigate={setCurrentPage} data-id="element-1" />;
      case 'rechner':
        return <RechnerPage onNavigate={setCurrentPage} data-id="element-2" />;
      case 'app':
        return <AppPage onNavigate={setCurrentPage} data-id="element-3" />;
      case 'beratung':
        return <BeratungPage onNavigate={setCurrentPage} data-id="element-4" />;
      case 'ueber-uns':
        return <UeberUnsPage onNavigate={setCurrentPage} data-id="element-5" />;
      case 'faq':
        return <FAQPage onNavigate={setCurrentPage} data-id="element-6" />;
      case 'kontakt':
        return <KontaktPage onNavigate={setCurrentPage} data-id="element-7" />;
      default:
        return <HomePage onNavigate={setCurrentPage} data-id="element-8" />;
    }
  };
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  return <div className="min-h-screen bg-white font-sans text-slate-900 antialiased" data-id="element-9">
      <Navbar currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-10" />
      <main data-id="element-11">{renderPage()}</main>
      <Footer onNavigate={setCurrentPage} data-id="element-12" />
    </div>;
}